<template>
	<div class="tab-pane fade" id="tab-companycontracts" role="tabpanel" aria-labelledby="companycontracts-tab">

		<div class="row section-top">
			<div class="col-md-12 pad0">
				<p class="section-lead">Lista de todos Contratos vinculados</p>
				<a href="#" @click="resetForm()" class="btn btn-outline-success float-right" data-toggle="modal" data-target="#modalCompanyContract"><i class="fas fa-plus"></i>&nbsp;Novo</a>
			</div>
		</div>

		<div class="row">
			<div class="col">

				<!-- table -->
				<div class="card p-4">
					<vue-good-table v-if="companyworkplacesItems.length"
						:columns="tableColumns"
						:rows="companyworkplacesItems"
						:pagination-options="tablePagination"
						:search-options="{
							enabled: true,
							placeholder: 'Buscar..',
						}"
						styleClass="vgt-table"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<div>
									<button class="btn btn-sm btn-outline-secondary" @click="editData(props.row)" title="Editar"><i class="far fa-edit"></i></button>
									<button class="btn btn-sm btn-outline-danger" @click="deleteData(props.row.id, props.row.originalIndex)" title="Deletar"><i class="far fa-trash-alt"></i></button>
								</div>
							</span>
							<span v-else>
								{{ props.formattedRow[props.column.field] }}
							</span>
						</template>
						<template slot="pagination-bottom">
							<table-pagination-component :_options="tablePaginationOptions" @paginate="pagination"></table-pagination-component>
						</template>
					</vue-good-table>
					<div v-else class="text-center p-3 text-muted">
						<h5>Nenhum Contrato vinculado!</h5>
					</div>
				</div>

				<div class="text-center p-4 text-muted" v-if="loading">
					<h5>Carregando...</h5>
					<p>Aguarde até que os dados sejam carregados...</p>
				</div>

			</div>

			<!-- modal -->
			<div class="modal fade" id="modalCompanyContract" tabindex="-1" aria-labelledby="modalCompanyContractLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="modalCompanyContractLabel">{{companyWorkplaceTitle}}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<form v-on:submit.prevent="saveData">

								<div class="row">

                  <!-- workplace -->
                  <div class="col-md-12">
										<div class="form-group">
											<label class="form-control-label" for="input-contract_id">Contrato</label>
											<v-select :options="workplaces" label="corporate_name" v-bind:class="{'is-invalid': errors.workplace}" v-model="contract_id" :reduce="corporate_name => corporate_name.id"></v-select>
											<div class="invalid-feedback d-block" v-if="errors.workplace">
												<p>{{ errors.workplace[0] }}</p>
											</div>
										</div>
									</div>
							
								</div>

								<div class="text-right">
									<button type="submit" class="btn btn-success">SALVAR</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<!-- end modal -->

		<vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
		</div>
	</div>
</template>

<script>
	import ApiService from '../../../apiservice.js';
	import configData from "../../../config.js";
	export default {
		mixins: [ApiService, configData],
		props: ['companies'],
		data() {
			return {
        colaborator_id: '',
        colaborators: [],
        colaboratorGroups: [],
        colaborator_group_id: '',
				companyWorkplaceTitle: "Vincular Contrato",
				colaboratorgroup: {
					name: '',
				},
				companyID: '',
				isEditCompanyWorkplaces: false,
				companyWorkPlaceID: "",
				companyworkplacesItems: [],
				fullPage: true,
				errors: [],
				loading: false,
        workplaces: [],
        contract_id: '',
				tablePagination: configData.tablePagination,
				tableColumns: [
				{
						label: 'ID',
						field: 'contracts.id',
					},{
						label: 'Nº Contrato',
						field: 'contracts.contract_number',
					},{
						label: 'Contrato',
						field: 'contracts.corporate_name',
					},{
						label: 'Data e Hora',
						field: 'created_at',
						type: 'date',
						dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
						dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
					},
					{
						label: 'Ações',
						field: 'actions',
						sortable: false,
						width: '100px'
					}
				],
				tablePaginationOptions: {
					currentPage: 1,
					currentPerPage: 10,
					from: 0,
					to: 0,
					total: null
				},
			}
		},
		mounted() {
			this.companyID = (JSON.parse(this.companies)).id;
      this.loadWorkPlaces();
      this.loadItems();
		},
		methods: {
			pagination(page){
				this.tablePaginationOptions = {
					currentPage: page.options.currentPage,
					currentPerPage: page.options.currentPerPage,
					from: page.options.from,
					to: page.options.to,
					total: page.options.total
				};
				this.loadItems();
			},
      loadWorkPlaces() {
				let _this = this;
				_this.loading = true;
				_this.workplaces = [];
				axios.get("/admin/contracts").then((res) => {
          _this.workplaces = _this.workplaces.concat(res.data);
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
			loadItems() {
				let _this = this;
				_this.loading = true;
				var params = {
					page: _this.tablePaginationOptions.currentPage,
					perPage: _this.tablePaginationOptions.currentPerPage,
				};
				_this.companyworkplacesItems = [];
				axios.post("/admin/companycontracts/"+this.companyID+"/filter", {}, {params: params}).then((res) => {
					const { data, total, from, to } = res.data.data;
					_this.tablePaginationOptions.total = total;
					_this.tablePaginationOptions.from = from;
					_this.tablePaginationOptions.to = to;
					_this.companyworkplacesItems = [...data];
          _this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
			saveData() {
				let _this = this;
				_this.errors = [];
				_this.loading = true;
				
				if (_this.isEditCompanyWorkplaces == true){

					let dataInfo = {
						"company": _this.companyID,
            "contract": _this.contract_id,
						"_method": "PATCH"
					};

					axios.post("/admin/companycontracts/"+_this.companyWorkPlaceID, dataInfo).then((res) => {

						_this.loading = false;
						_this.resetForm();

						$('#modalCompanyContract').modal('hide');

						//call function in ApiService to validate success
						_this._api_validateSuccess(res,false);

					}).catch((err) => {

						_this.loading = false;

						if (err.response.data.errors){
							//set errors
							_this.errors = err.response.data.errors;
						}
						//call function in ApiService to validate error
						_this._api_validateError(err);

					});

				} else {

					let dataInfo = {
						"company": _this.companyID,
            "contract": _this.contract_id,
						"last": ""
					};
					axios.post("/admin/companycontracts", dataInfo).then((res) => {

						_this.loading = false;
						_this.resetForm();

						_this.companyworkplacesItems.push(res.data.data);
						$('#modalCompanyContract').modal('hide');

						//call function in ApiService to validate success
						_this._api_validateSuccess(res,false);

					}).catch((err) => {

						_this.loading = false;

						if (err.response.data.errors){
							//set errors
							_this.errors = err.response.data.errors;
						}

						//call function in ApiService to validate error
						_this._api_validateError(err);

					});
				}
			},
			deleteData(ID, index) {
				let _this = this;

				//show alert confirmation
				_this.$swal({
					title: "Excluir vínculo de Contrato",
					text: "Tem certeza que deseja excluir esse vínculo?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonText: "Excluir",
					cancelButtonText: "Cancelar"
				}).then((alertConfirm) => {

					//validate isConfirmed
					if (alertConfirm.isConfirmed) {

						//remove
						axios.delete("/admin/companycontracts/"+ID).then((res) => {

							_this.companyworkplacesItems.splice(index, 1);

							//call function in ApiService to validate success
							_this._api_validateSuccess(res,false);

						}).catch(err => {

							_this.loading = false;

							//call function in ApiService to validate error
							_this._api_validateError(err);

						});

					}//end validate isConfirmed

				});
				//end alert confirmation

			},
			editData(item){

        this.contract_id = item.contract_id;

				this.isEditCompanyWorkplaces = true;
				this.companyWorkPlaceID = item.id;
				this.companyWorkplaceTitle = "Editar vínculo de Contrato";

				$("#modalCompanyContract").modal('show');

			},
			resetForm(){

				this.colaborator_id = "";
				this.colaborator_group_id = "";
        this.contract_id = "";

				this.loadWorkPlaces();

			}
		}
	}
</script>
